module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "has-sub"
  }, [_c('ul', [_c('li', {
    staticClass: "active pageLink",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/home.svg",
      "alt": "Home"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Home")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "pageLink",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/report"
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Report")])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b97f3f28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenu.vue
// module id = 319
// module chunks = 1